(function() {
    'use strict';

    angular
        .module('app.archivoAsociacion')
        .run(appRun);

    // appRun.$inject = ['routehelper'];

    /* @ngInject */
    function appRun(routehelper) {
        routehelper.configureRoutes(getRoutes());
    }

    function getRoutes() {
        return [
            {
                url: '/archivo-asociacion',
                config: {
                    templateUrl: 'app/archivoAsociacion/archivoAsociacion.html',
                    controller: 'ArchivoAsociacion',
                    controllerAs: 'vm',
                    title: 'ArchivoAsociacion'
                }
            },
            {
                url: '/datos-archivo-asociacion/:tipoPlanillaId?/:planillaId?',
                config: {
                    templateUrl: 'app/archivoAsociacion/datosArchivoAsociacion.html',
                    controller: 'DatosArchivoAsociacion',
                    controllerAs: 'vm',
                    title: 'DatosArchivoAsociacion'
                }
            }
        ];
    }
})();
